import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUserPreference } from "../contexts/UserPreferenceContext";
import { usePDFAuth } from "../contexts/PDFAuthContext";


const SWERedirect = () => {
  const navigate = useNavigate();
  const { setSoftwarePreference } = useUserPreference();
  const { authenticate } = usePDFAuth();

  useEffect(() => {
    setSoftwarePreference();
    
    authenticate();
    
    navigate("/experience?tab=software", { replace: true });
  }, [navigate, setSoftwarePreference, authenticate]);

  return null;
};

export default SWERedirect;
